module.exports = __webpack_public_path__ + "assets/images/locker.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/locker.png
// module id = 252
// module chunks = 1